import qs from 'qs'
import axios from '@/api/apiClient'

/**
 * 企业api
 */
const api = {
  /** 申请成为主办商 */
  // applyOrganize: '/api/company/myaudit/organize',
  applyOrganize: '/api/company/myaudit/lang/organize',
  /** 申请成为参展商 更新新的 */
  // applyExhibitor: '/api/company/myaudit/exhibitor',
  applyExhibitor: '/api/company/myaudit/lang/newexhibitor',
  /** 申请成为展厅工程商 */
  applyContractor: '/api/company/myaudit/showroom',
  /** 申请成为模型设计师-认证个人 */
  applyDesignperson: '/api/company/myaudit/designperson',
  /** 申请成为模型设计师-公司 */
  applyDesigncompany: '/api/company/myaudit/designcompany',
  /** 修改公司资料 */
  applyUpdateInfo: '/api/company/myaudit',
  /** 获取我的基本的企业信息 */
  getCompanyMyinfo: '/api/company/myinfo/lang/alldetail',
  /** 获取参展商的企业信息 */
  getExhibitorInfo: '/api/company/myinfo/newedit',
  /** 获取我的联系信息 */
  bizcontect: '/api/company/myinfo/bizcontect',

  // 获取营业执照
  businessliscense: '/api/company/info/businesslicense',

  // 获取展览服务-设计师
  modelDesign: '/api/company/info/moxingdesign',
  // 获取展览服务-工程商
  showroomProvider: '/api/company/info/showroomprovider',

  // 根据环信ID获取用户信息
  getMemberInfoBycode: '/api/company/info/getMemberInfoBycode',

  // 展厅定制
  customized: '/api/company/mycustomized',
  // 编辑企业信息
  updatecloudsystem: '/api/company/myaudit/lang/updatecloudsystem',

  /**
   * 新的云展系统
   */
  // 企业基本信息
  cloudInfo: '/api/company/info/cloud',

  // 企业云展大一统接口
  cloudSystem: '/api/company/cloudSystem/indexData',

  // 投资机构,对外投资,合作伙伴列表
  cloudInvestPage: '/api/company/invest/page',
  // 企业动态列表
  cloudColumnPage: '/api/company/column/page',
  // 企业相册, 企业荣誉列表
  cloudFilePage: '/api/company/file/page',
  // 招标列表-企业主页
  organizeInfo: '/api/biding/info/organize',
  // 企业招标
  cloudBiding: '/api/biding/info/organize',

  // 企业主页-云招聘
  recruitmentPage: '/api/recruitment/company/page',

  // 企业主页-云优惠
  companyCoupon: '/api/coupon/company/page',

  // 获取企业的面板数据
  myinfoCloud: '/api/company/myinfo/cloud',
  // 弃用 提醒更新
  // sendRemind: '/api/company/info/sendRemind',
  // 企业动态详情页
  columnDetail: '/api/company/column/detail',

  // 点赞企业
  infoLike: '/api/company/info/like',
  // 点赞列表
  linkList: '/api/company/info/viewMemberList',
}
export default api
export const applyUpdateInfo = (param) => {
  console.log('修改公司资料', param)
  return axios.$put(api.applyUpdateInfo, param)
}
// 申请成为主办商
export const applyOrganize = (param) => {
  console.log('申请成为主办商', param)
  return axios.$post(api.applyOrganize, param)
}
/**
 * 申请成为参展商
 * @interface https://www.tapd.cn/38059561/markdown_wikis/view/#1138059561001000713
 * @param {*} param
 */
export const applyExhibitor = (param) => {
  return axios.$post(api.applyExhibitor, param)
}
/**
 * 修改参展商资料
 * @interface https://www.tapd.cn/38059561/markdown_wikis/view/#1138059561001000717
 * @param {*} param
 */
export const applyUpdateExhibitor = (param) => {
  return axios.$put(api.applyExhibitor, param)
}
/**
 * 获取参展商资料
 * @interface https://www.tapd.cn/38059561/markdown_wikis/view/#1138059561001000720
 * @param {*} param
 */
export const getExhibitorInfo = () => {
  return axios.$get(api.getExhibitorInfo)
}

/**
 * 根据环信ID获取用户信息
 * @interface https://www.tapd.cn/38059561/markdown_wikis/show/#1138059561001000686
 * @param {*} param
 */
export const getMemberInfoBycode = (query) => {
  return axios.$get(`${api.getMemberInfoBycode}${query ? `?${qs.stringify(query)}` : ''}`)
}

export const applyContractor = (param) => {
  console.log('申请成为展厅工程商', param)
  return axios.$post(api.applyContractor, param)
}
export const applyDesignperson = (param) => {
  console.log('申请成为模型设计师-认证个人', param)
  return axios.$post(api.applyDesignperson, param)
}
export const applyDesigncompany = (param) => {
  console.log('申请成为模型设计师-公司', param)
  return axios.$post(api.applyDesigncompany, param)
}

export const getCompanyMyinfo = () => {
  return axios.$get(api.getCompanyMyinfo)
}
export const getBizcontect = () => {
  return axios.$get(api.bizcontect)
}

export const getBusinessliscense = (id) => {
  return axios.$get(`${api.businessliscense}/${id}`)
}
// 修改业务联系信息
export const putBizcontect = (param) => {
  return axios.$put(api.bizcontect, param)
}

// 个人页-展厅定制
export const setCustomized = (param) => {
  return axios.$post(api.customized, param)
}
// 定制管理-获取收到的定制申请
export const getCustomized = (query) => {
  return axios.$get(`${api.customized}${query ? `?${qs.stringify(query)}` : ''}`)
}
// 展厅服务-设计师
export const getModelDesign = (query) => {
  return axios.$get(`${api.modelDesign}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 展厅服务-工程商
export const getShowroomProvider = (query) => {
  return axios.$get(`${api.showroomProvider}${query ? `?${qs.stringify(query)}` : ''}`)
}

export const updatecloudsystem = (params) => {
  return axios.$put(`${api.updatecloudsystem}`, params)
}

// 获取云展访问面板
export const getMyinfoCloud = (query) => {
  return axios.$get(`${api.myinfoCloud}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 获取个人身份的云展访问面板
export const getMyinfoCloudByMy = (query) => {
  return axios.$get(`api/myMemberCardCloudSystemLog/myCardStatistics${query ? `?${qs.stringify(query)}` : ''}`)
}

// 获取会展信息
export const getCloudInfo = (query) => {
  return axios.$get(`${api.cloudInfo}/${query}`)
}

export const getCompanyHome = (query, language) => {
  return axios.$get(`${api.cloudInfo}/${query}`, {
    'Terminal-Language': language,
  })
}

export const companyCloudSystem = (memberCode, language) => {
  return axios.$get(`/api/company/cloudSystem/indexData/${memberCode}`, {
    'Terminal-Language': language,
  })
}

// 获取企业云展大一统数据
export const getCloudSystemDetail = (memberCode) => {
  return axios.$get(`${api.cloudSystem}/${memberCode}`)
}

// 获取企业动态

export const getCloudColumnPage = (skey, memunicode, query) => {
  return axios.$get(`${api.cloudColumnPage}/${skey}/${memunicode}${query ? `?${qs.stringify(query)}` : ''}`)
}

export const getColumnDetail = (dynamicId, query) => {
  return axios.$get(`${api.columnDetail}/${dynamicId}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 投资机构,对外投资,合作伙伴列表
export const getCloudInvestPage = (skey, memunicode, query) => {
  return axios.$get(`${api.cloudInvestPage}/${skey}/${memunicode}${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * 企业相册, 企业荣誉列表
 * @param {*} skey
 * @param {*} memunicode
 * @param {*} query
 * @returns
 */
export const getCloudFilePage = (skey, memunicode, query) => {
  return axios.$get(`${api.cloudFilePage}/${skey}/${memunicode}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 获取企业招聘列表
export const getRecruitmentPage = (query) => {
  return axios.$get(`${api.recruitmentPage}${query ? `?${qs.stringify(query)}` : ''}`)
}
// 获取企业优惠
export const getCompanyCoupon = (query) => {
  return axios.$get(`${api.companyCoupon}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 获取招标
export const getCloudBiding = (memunicode, query) => {
  return axios.$get(`${api.cloudBiding}/${memunicode}${query ? `?${qs.stringify(query)}` : ''}`)
}

// 发送提醒
// export const setSendRemind = (params) => {
//   return axios.$post(api.sendRemind, params)
// }

// 点赞企业
export const setInfoLike = (data) => {
  return axios.$post(api.infoLike, { ...data })
}

export const getLinkList = (query) => {
  return axios.$get(`${api.linkList}/${query ? `?${qs.stringify(query)}` : ''}`)
}

/**
 * @description: 企业名称是否存在校验
 * @param {*} companyName
 * @return {*}
 */
export const checkCompanyNameExist = (companyName) => {
  return axios.$get(`/api/company/info/exist/${companyName}`)
}

// 产品详情页顶部的公司信息
export const getProductTopCompanyInfo = (query) => {
  return axios.$get(`/api/company/info/oneWithThirdd${query ? `?${qs.stringify(query)}` : ''}`)
}

// 获取我的面板
export const getMyCloudCompany = (language) => {
  return axios.$get(`${api.myinfoCloud}`, {
    headers: language
      ? {
          'Terminal-Language': language,
        }
      : null,
  })
}

/**
 * 校验企业是否已认证
 * @param {*} companyName 企业名称
 */
export const checkCompanyIsAuth = (query) => {
  return axios.$get(`/api/company/myaudit/checkCompanyName${query ? `?${qs.stringify(query)}` : ''}`)
}

// 企业宣传册分页查询
export const getCompanyBrochurePage = (query) => {
  return axios.$get(`/api/company/mybrochure/page${query ? `?${qs.stringify(query)}` : ''}`)
}

// 企业宣传册批量删除
export const deleteCompanyBrochure = (data) => {
  return axios.$post(`/api/company/mybrochure/batch/delete`, data)
}

// 企业宣传册单个删除
export const deleteCompanyBrochureById = (id) => {
  return axios.$get(`/api/company/mybrochure/delete/${id}`)
}

// 企业宣传册上传pdf、ppt文件
export const uploadCompanyBrochure = (file) => {
  const param = new FormData()

  param.append('file', file)

  return axios.$post(`/api/company/mybrochure/upload`, param, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

// 资质信息列表
export const getCompanyLicensePage = (query) => {
  return axios.$get(`/api/company/license/page${query ? `?${qs.stringify(query)}` : ''}`)
}

// 资质信息详情
export const getCompanyLicenseDetail = (id) => {
  return axios.$get(`/api/company/license/detail${id ? `?id=${id}` : ''}`)
}

// 资质信息删除
export const deleteCompanyLicense = (id) => {
  return axios.$get(`/api/company/license/delete${id ? `?id=${id}` : ''}`)
}

// 资质信息添加
// 参数和修改一样,  不过不用传id
export const addCompanyLicense = (data) => {
  return axios.$post(`/api/company/license/save`, data)
}

// 资质信息修改
/**
 {
    "id": 1,
    // 公司id
    "companyId": "1818097588753412096",
    // 资质文件代码 
    "licenseCode": "111",
    // 资质文件名称
    "licenseName": "111",
    // 资质文件简称
    "licenseAbbreviation": "111",
    // 证件有效日期
    "issueTime": "2025-01-01",
    // 证件失效日期
    "issueEndTime": "2025-12-12",
    // 附件
    "attachedFile": "https://images6396289.oss-cn-shenzhen.aliyuncs.com/images/b0pcq7fblbmzte8u.jpg"
}
 */
export const updateCompanyLicense = (data) => {
  return axios.$post(`/api/company/license/update`, data)
}
